export default __webpack_public_path__ + "9005849859afeb88eae96b796122b32e.png";